(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdna-dress-guide"] && !Shopify.designMode) return;
  try {
    
  // Occasion finder: pills swap the pre-rendered preview panels in place.
  // Pills are real collection links, so without JS they simply navigate (crawlable fallback).
  (function () {
    document.querySelectorAll('[data-cdna-finder]').forEach(function (finder) {
      var pills = finder.querySelectorAll('.cdna-guide__finder-pill');
      var panels = finder.querySelectorAll('.cdna-guide__finder-panel');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          var occ = pill.getAttribute('data-occ');
          pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
          panels.forEach(function (panel) {
            var on = panel.getAttribute('data-occ') === occ;
            panel.classList.toggle('is-active', on);
            if (on) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpd-video-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lpd-video-reels')) {
    class LpdVideoReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lpd-reels__track');
        if (!this.track) return;
        this.videos = Array.from(this.querySelectorAll('video.lpd-reels__video'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection && navigator.connection.saveData;
        this.auto = this.dataset.autoplay === 'true' && !this.reduceMotion && !saveData;
        this.ratios = new Map();
        this.state = new Map();

        this.loadObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.load(entry.target);
              this.loadObserver.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 200px 0px 200px' });

        this.playObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.ratios.set(entry.target, entry.intersectionRatio));
          this.sync();
        }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });

        this.videos.forEach((video) => {
          this.state.set(video, { userPaused: false, userPlay: false });
          this.loadObserver.observe(video);
          this.playObserver.observe(video);
          const card = video.closest('.lpd-reels__card');
          card.querySelector('.lpd-reels__tap').addEventListener('click', () => this.toggle(video));
          card.querySelector('.lpd-reels__sound').addEventListener('click', () => this.toggleSound(video));
        });

        this.onGlobalPlay = (event) => { if (event.detail !== this) this.pauseAll(); };
        document.addEventListener('lpd-reels:play', this.onGlobalPlay);
        this.onHidden = () => { if (document.hidden) this.pauseAll(); };
        document.addEventListener('visibilitychange', this.onHidden);

        this.prev = this.querySelector('.lpd-reels__arrow--prev');
        this.next = this.querySelector('.lpd-reels__arrow--next');
        this.querySelectorAll('.lpd-reels__arrow').forEach((button) => {
          button.addEventListener('click', () => {
            const dir = Number(button.dataset.dir);
            this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: this.reduceMotion ? 'auto' : 'smooth' });
          });
        });
        this.track.addEventListener('scroll', () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = 0; this.updateArrows(); });
        }, { passive: true });
        this.updateArrows();

        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: this.reduceMotion ? 'auto' : 'smooth' });
        });
      }

      disconnectedCallback() {
        if (this.loadObserver) this.loadObserver.disconnect();
        if (this.playObserver) this.playObserver.disconnect();
        document.removeEventListener('lpd-reels:play', this.onGlobalPlay);
        document.removeEventListener('visibilitychange', this.onHidden);
        if (this.videos) this.videos.forEach((video) => video.pause());
      }

      load(video) {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        });
      }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }

      setUi(video, playing) {
        const card = video.closest('.lpd-reels__card');
        const tap = card.querySelector('.lpd-reels__tap');
        tap.setAttribute('aria-pressed', String(playing));
        const label = video.getAttribute('aria-label');
        tap.setAttribute('aria-label', (playing ? 'Pause video: ' : 'Play video: ') + label);
      }

      play(video) {
        this.load(video);
        document.dispatchEvent(new CustomEvent('lpd-reels:play', { detail: this }));
        this.videos.forEach((other) => { if (other !== video && !other.paused) this.stop(other); });
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => this.setUi(video, false));
        this.setUi(video, true);
      }

      stop(video) {
        video.pause();
        this.setUi(video, false);
      }

      pauseAll() {
        if (this.videos) this.videos.forEach((video) => { if (!video.paused) this.stop(video); });
      }

      toggle(video) {
        const state = this.state.get(video);
        if (video.paused) {
          state.userPaused = false;
          state.userPlay = true;
          this.play(video);
        } else {
          state.userPaused = true;
          state.userPlay = false;
          this.stop(video);
        }
      }

      toggleSound(video) {
        const button = video.closest('.lpd-reels__card').querySelector('.lpd-reels__sound');
        video.muted = !video.muted;
        button.setAttribute('aria-pressed', String(!video.muted));
        button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
        if (!video.muted && video.paused) {
          this.state.get(video).userPlay = true;
          this.state.get(video).userPaused = false;
          this.play(video);
        }
      }

      sync() {
        let target = null;
        let best = 0;
        this.ratios.forEach((ratio, video) => { if (ratio > best) { best = ratio; target = video; } });
        if (best < 0.6) target = null;
        this.videos.forEach((video) => {
          const state = this.state.get(video);
          const ratio = this.ratios.get(video) || 0;
          if (ratio < 0.2) { state.userPaused = false; state.userPlay = false; }
          if (video === target && (state.userPlay || (this.auto && !state.userPaused))) {
            if (video.paused) this.play(video);
          } else if (!video.paused) {
            this.stop(video);
          }
        });
      }
    }
    customElements.define('lpd-video-reels', LpdVideoReels);
  }

  } catch(e) { console.error(e); }
})();
})();
